module.exports = __webpack_public_path__ + "static/media/yamnaya_icon_small.33275ef4.png";